import { useContent, useSectionMeta } from "../content/ContentContext";
import { Reveal, Chapter } from "./Reveal";

export const Creator = () => {
  const { SITE } = useContent();
  const meta = useSectionMeta("creator");

  return (
    <section id="creator" className="relative py-24 md:py-36" data-testid="creator-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <Reveal>
              <Chapter number={meta.number} label={meta.label} id="creator" />
              <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-tight" data-testid="creator-heading">
                ABOUT THE <span className="italic text-gold-light">CREATOR</span>
              </h2>
            </Reveal>
            <Reveal delay={0.12}>
              <p className="text-sm md:text-base text-smoke mt-7 max-w-xl leading-relaxed" data-testid="creator-text">
                {SITE.creator.text}
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="mt-10 grid sm:grid-cols-2 gap-8 max-w-xl">
                <div data-testid="creator-credit-produced">
                  <p className="text-[10px] tracking-[0.34em] uppercase text-smoke">Created & Produced by</p>
                  <p className="font-display text-2xl text-ivory mt-2">{SITE.creator.producedBy}</p>
                </div>
                <div data-testid="creator-credit-written">
                  <p className="text-[10px] tracking-[0.34em] uppercase text-smoke">Written by</p>
                  <p className="font-display text-2xl text-ivory mt-2">{SITE.creator.writtenBy}</p>
                </div>
              </div>
            </Reveal>
          </div>
          <Reveal className="lg:col-span-5" delay={0.15}>
            <div className="relative overflow-hidden rounded-sm aspect-[3/4] max-w-sm mx-auto lg:ml-auto">
              <img
                src={SITE.creator.image}
                alt="The creator of WE NEED TO TALK on set"
                className="w-full h-full object-cover img-cinematic"
                data-testid="creator-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-transparent" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
